import Vue from "vue";
import Router from "vue-router";
//import Index from "./views/Index.vue";
import Landing from "./views/Landing.vue";
import Retratar from "./views/Retratar.vue";
import Retratar2 from "./views/Retratar2.vue";
//import Login from "./views/Login.vue";
//import Profile from "./views/Profile.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainNavbarRetratar from "./layout/MainNavbarRetratar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
  routes: [    
    {
      path: "/",
      name: "index",
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },{
      path: "/retratar",
      name: "retratar",
      components: { default: Retratar, header: MainNavbarRetratar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 }
      }
    },{
      path: "/retratar2",
      name: "retratar2",
      components: { default: Retratar2, header: MainNavbarRetratar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
